"use client";

import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import VideoCard from "./VideoCard";
import { cn } from "@/lib/utils";

export default function VideoRow({ videos, vertical = false, className = "", children }) {
  const ref = useRef(null);

  const scroll = (dir) => {
    if (!ref.current) return;
    ref.current.scrollBy({ left: dir * ref.current.clientWidth * 0.8, behavior: "smooth" });
  };

  return (
    <div className={cn("relative group/row", className)}>
      <button
        onClick={() => scroll(-1)}
        aria-label="Scroll left"
        className="absolute left-2 top-[40%] z-10 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-black/70 text-white opacity-0 transition-opacity group-hover/row:opacity-100 md:flex"
      >
        <ChevronLeft className="h-5 w-5" />
      </button>
      <div ref={ref} className="h-scroll no-scrollbar flex gap-4 overflow-x-auto px-1 pb-4">
        {children ||
          videos.map((v) => <VideoCard key={v.id} video={v} vertical={vertical} />)}
      </div>
      <button
        onClick={() => scroll(1)}
        aria-label="Scroll right"
        className="absolute right-2 top-[40%] z-10 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-black/70 text-white opacity-0 transition-opacity group-hover/row:opacity-100 md:flex"
      >
        <ChevronRight className="h-5 w-5" />
      </button>
    </div>
  );
}
